<script>
import AudioDescriptionExport from "./AudioDescriptionExport.svelte";
</script>

<AudioDescriptionExport variant="dubbing" />
